import AnalyticsEvent from './AnalyticsEvent';

class MediaPlayerStatus extends AnalyticsEvent {
	constructor(userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent) {
		
		super(userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent);
		
		this.className = "MediaPlayerEvent";
		this.dbDest = 'media_status';

		this._volumeTarget = null;
		this._screenState = null;
		this._label = null;
		this._scene = null;
		this._timecode = -1;
		this._error = '';
		this._type = '';
	}

	appendBaseParams(uId, d) {
		this.append(uId, d);
	}
}

Object.defineProperty(MediaPlayerStatus.prototype, "gaEventSet", {
	get: function () {
		var urlComps = this.simulatedURL.split('_');

		this._gaEventSet.category = urlComps[0];
		this._gaEventSet.action = urlComps[1];
		this._gaEventSet.label = urlComps[2];
		urlComps.length > 3 ? this._gaEventSet.value = urlComps[4] : null;
		return this._gaEventSet;
	}
});

Object.defineProperty(MediaPlayerStatus.prototype, 'timecode', {
	set: function (tcode) {
		this._timecode = tcode;
		this.simulatedURL = this.simulatedURL.replace('[time]', this._timecode);
	},
	get: function () { return this._timecode; }
});

Object.defineProperty(MediaPlayerStatus.prototype, 'type', {
	set: function (tcode) {
		this._type = tcode;
		this.simulatedURL = this.simulatedURL.replace('[type]', this._type);
	},
	get: function () { return this._type; }
});


Object.defineProperty(MediaPlayerStatus.prototype, "screenstate", {
	set: function (state) {
		this._screenState = (state) ? 'on' : 'off';
		this.simulatedURL = this.simulatedURL.replace('[screenstate]', this._screenState);
	},
	get: function () { return this._screenState; }
});

Object.defineProperty(MediaPlayerStatus.prototype, "label", {
	set: function (label) {
		this._label = label


		this.simulatedURL = this.simulatedURL.replace('[label]', this._label);

	},
	get: function () { return this._label; }
});

Object.defineProperty(MediaPlayerStatus.prototype, "scene", {
	set: function (scene) {
		this._scene = scene;

		this._gaEventSet.value = this._scene;

		this.simulatedURL = this.simulatedURL.replace('[scene]', this._scene);
	},
	get: function () { return this._scene; }
});

Object.defineProperty(MediaPlayerStatus.prototype, "error", {
	set: function (error) {
		this._error = error;


		this.simulatedURL = this.simulatedURL.replace('[error]', this._error);
	},
	get: function () { return this._error; }
});


export default MediaPlayerStatus;


// WEBPACK FOOTER //
// ./src/analytics/analytics-events/MediaPlayerStatus.js